import { APIClient, PaginatedResponse } from '@frontend/api-utils';
import { Colli, ColliStateName, ColliTriggerName } from '@frontend/colli/types';
import { PossibleTrigger, TriggerBody } from '@frontend/workflow/types';

export class ColliWorkflowClient extends APIClient {
    public static readonly endpoint = '/colli-api/v1';

    public static async updateColliState(accountId: string, transactionId: string, colliId: string, state: ColliStateName): Promise<Colli> {
        const response = await this.patch(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/change-state`, {
            state: state
        });
        return await this.handleResponse<Colli>(response);
    }

    public static async triggerColliState(accountId: string, transactionId: string, colliId: string, trigger: TriggerBody<ColliTriggerName>): Promise<void> {
        const response = await this.post(`${this.endpoint}/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/trigger`, trigger);
        return await this.handleVoidResponse(response);
    }

    public static async fetchColliPossibleTriggers(
        accountId: string,
        transactionId: string,
        colliId: string
    ): Promise<PossibleTrigger<ColliTriggerName, ColliStateName>[]> {
        const response = await this.fetch(`/colli-api/v2/accounts/${accountId}/transactions/${transactionId}/collis/${colliId}/possible-triggers`);
        const body = await this.handleResponse<PaginatedResponse<PossibleTrigger<ColliTriggerName, ColliStateName>>>(response);
        return body.results;
    }
}
